import { Button, Typography } from '@material-ui/core';
import React from 'react';
import TimeLineCom, { CoustorTimelineSeparator } from './Timeline'
import resumeData from '../../Utils/resumeData'
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineContent from '@material-ui/lab/TimelineContent';
// Icon 
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import GetAppIcon from '@material-ui/icons/GetApp';
// css 
import './Profile.css'
//img
import me from '../../assets/img/me.jpg'
import CustomButton from '../Button/Button';



//>>>>>>>>>>>

const CustomTimeLine = ({title, text, link}) =>(
    <TimelineItem className="timeline_content" >
        <CoustorTimelineSeparator />
        <TimelineContent >
            { link ? (<Typography  className="timeLine_txt">
                <span style={{fontWeight:'bold', color:'black'}} >{title}:</span> {" "}  <a className="none" href={link} target="_blank" >{text} </a>
                 </Typography>): (
                <Typography   className="timeLine_txt">
            <span  style={{fontWeight:'bold', color:'black'}} >{title }:-</span>{" "}  <span>{text}</span>
                
                </Typography>
            )}
        </TimelineContent>
    </TimelineItem>
)



const Profile = () => {
    return (
        <div className="profile container_shadow">
            <div className='profile_name'>
                <Typography className='name'>
                   {resumeData.name}
                </Typography>
                <Typography className='title'>
                   {resumeData.title}
                </Typography>
                <div className="profile_img">
                    <img src={me} alt="Mr.jIM" />
                </div>
                <div className='profile_Information'>
                   <TimeLineCom  
                   icon = {<PersonOutlineIcon />}
                   >
                       <CustomTimeLine  
                       title ="Name" text={resumeData.name}
                       />
                       <CustomTimeLine  
                       title ="Title" text={resumeData.title}
                       />
                       <CustomTimeLine  
                       title ="Email" text={resumeData.Email}
                       />

                       {
                           Object.keys(resumeData.socile).map(key => (
                            <CustomTimeLine  
                            title ={key} text={resumeData.socile[key].text}
                            link ={resumeData.socile[key].link}
                            />
                           ))
                       }
                   </TimeLineCom>
                 {/* button is hare  */}
                 <div className="profile_btn">
                 <CustomButton text={"Dawonload CV"} icon={<GetAppIcon />} />

                 </div>
                </div>
            </div>
           
        </div>
    );
};

export default Profile;